var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "material-input",
    {
      staticClass: "no-border",
      attrs: {
        id: "select-lender-search",
        "no-label": "",
        label: _vm.$t("global.words.search"),
        "hidden-label": true,
      },
    },
    [
      _c("v-select-field", {
        staticClass: "search-input w-100 vsSelectedCheckboxes",
        attrs: {
          options: _vm.formattedLenderOptions,
          placeholder: _vm.$t("global.actions.chooseOption"),
          label: "label",
          "remove-duplicates-by": "id",
          clearable: _vm.clearable,
          "default-value": _vm.localSelectedLender,
          multiple: _vm.multiple,
          "search-min-characters": 1,
          action: _vm.action,
          autoscroll: false,
          "deselect-from-dropdown": "",
          "has-checkboxes": "",
        },
        on: {
          "option:selected": _vm.handleChange,
          "option:deselected": _vm.handleChange,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }